import React from "react";


const PaginationBtn = ({onClick, left}) => <button
    className={"td-stage-list__nav-btn td-stage-list__nav-btn--" + (left && 'previous' || 'next') }
    onClick={onClick}>
    <span className={"glyphicon glyphicon-menu-" + (left && 'left' || 'right')}/>
</button>;

const ClassificationList = ({classifications, onChange, onClick, activeStage}) => {
    if (!classifications) {
        return null
    }
    return <div className="td-stage-list">
        <PaginationBtn left onClick={() => onChange(-1)}/>
        {classifications.map(classification => <Classification
            key={classification.index}
            onClick={onClick}
            classification={classification}
            active={classification.index == activeStage}/>)}
        <PaginationBtn onClick={() => onChange(1)}/>
    </div>
};

class Classification extends React.PureComponent {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick() {
        this.props.onClick(this.props.classification)
    }
    render() {
        return <button
            onClick={this.handleClick}
            disabled={this.props.active}
            className={`td-stage td-stage-list__stage ${this.props.active ? 'td-stage-list__stage--active' : ''}`}>
            <div className="td-stage__date">{this.props.classification.startsOn}</div>
            <div className="td-stage__name">{this.props.classification.name}</div>
            <div className="td-stage__index-badge">{this.props.classification.index}</div>
        </button>;
    }
}

export default ClassificationList;
